function customSelectors(){
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    if(!selElmnt.classList.contains('added')){
      selElmnt.classList.add('added')
      ll = selElmnt.length;
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      let attr = selElmnt.getAttribute('data-option-name')
      a.setAttribute("data-option-name", attr);
      x[i].appendChild(a);
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 0; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        if(j === 0 ) {
          c.classList.add('same-as-selected')
        }
        c.setAttribute('data-value', selElmnt.options[j].value)
        c.addEventListener("click", function(e) {
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                h.setAttribute('data-value', this.getAttribute('data-value'))
                if(h.previousSibling.previousSibling && h.previousSibling.previousSibling.hasAttribute('data-option')){
                  h.setAttribute('data-option-name', h.previousSibling.previousSibling.getAttribute('data-option-name'))
                  let base_select = '#' + h.previousSibling.previousSibling.getAttribute('data-option')
                  let value = h.getAttribute('data-value')
                  document.querySelector(base_select).value = value
                  document.querySelector(base_select).onchange();
                }
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
        this.classList.add("select-activated");
      });
    }
  
  }

  function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }
  document.addEventListener("click", closeAllSelect);
}

document.addEventListener('DOMContentLoaded', ()=>{
  customSelectors()

  document.querySelectorAll('.quickview-eye').forEach(el=>{
    el.addEventListener('click', ()=>{
      setTimeout(function(){
        customSelectors()
      }, 500)
    })
  })
})